import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Snackbar, TextField, Button, Box, Typography, Paper, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { loginUserBase64Image } from '../assets/loginuserbg';
import logo_con_scritta from "../assets/logo_con_scritta.svg";
import { setCookie } from '../services/cookies';
import PublicLogo from "../components/PublicLogo";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PublicLayout from "../components/PublicLayout";
import PublicHeader from "../components/PublicHeader";
import LogoutIcon from '@mui/icons-material/Logout';
import deluser from '../assets/icons/deluser.svg';
import { MODALTYPE, ModalData, modalDataClean, ModalAlert } from '../components/ModalAlert';
import { ReactComponent as AlertMessageDisactivate } from '../assets/icons/alertMessagedisactivate.svg';

const GestionePrivacy: React.FC = () => {

    const [error, setError] = useState<string | null>(null);
    const [showPassword, setShowPassword] = useState(false);

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const navigate = useNavigate()

    const [token, setToken] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [email, setEmail] = useState<string>('');

    const [modalData, setModalData] = useState<ModalData>(modalDataClean);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState<{
        icon: React.ReactNode | null;
        message: string;
    }>({ icon: null, message: "" });

    const closeModal = () => setModalData({ ...modalData, show: false });

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await fetch('/api/v0/login', {
                method: 'POST',
                body: JSON.stringify({ username, password }),
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                const data = await response.json();
                setUsername('')
                setPassword('')
                setToken(data.token)
                setName(data.name)
                setEmail(data.email)
            } else {
                const errorData = await response.json();
                setError(errorData.error);
            }
        } catch (error) {
            setError('Si è verificato un errore, per favore riprova più tardi.');
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleDisconnectClick = () => {
        setToken('')
        setName('')
        setEmail('')
        setError(null)
    }

    const eliminaUtente = async (email: string) => {
        try {
            const headers = new Headers();
            headers.set("Accept", "application/json");
            headers.set('Authorization', `Token ${token}`);

            const response = await fetch(`/api/v0/user/${email}`, {
                method: "DELETE",
                credentials: "include",
                headers,
            });

            if (!response.ok) {
                const text = await response.text().catch(() => "");
                throw new Error(text || "Errore durante l'eliminazione dell'utente");
            }

            setSnackbarMessage({
                icon: <AlertMessageDisactivate />,
                message: "Utente eliminato con successo",
            });
            setSnackbarOpen(true);

            handleDisconnectClick();
        } catch (error: any) {
          // console.error("Errore durante la chiamata DELETE:", error);
          setSnackbarMessage({
            icon: <AlertMessageDisactivate />,
            message: error.message || "Errore durante l'eliminazione dell'utente",
          });
          setSnackbarOpen(true);
        }
    }

    const handleDeleteUser = () => {
        eliminaUtente(email)
    }


    return (
        <>
        {token=='' ? 
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
                bgcolor="#f5f5f5"
                sx={{
                    backgroundImage: `url(${loginUserBase64Image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: 17,
                }}
            >
                <div className='white-panel p-5'>
                    <PublicLogo />
                    <Typography variant="h4" my={2} >Gestione privacy</Typography>
                    <div className='mb-3'>
                        <TextField
                            fullWidth
                            label="Username"
                            margin="normal"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className='mb-3'>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={togglePasswordVisibility}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    {error && <Typography color="error" variant="body2">{error}</Typography>}
                    <div className='mt-3 text-center'>

                        <button className='btn text-center' style={{ backgroundColor: "#0D5C37", color: "white", alignItems: "center", }} onClick={handleLogin}>
                            Accedi
                        </button>
                    </div>

                </div>
            </Box>
        :
            <PublicLayout>
                <Box 
                  display="flex" 
                  flexDirection="column" 
                  alignItems="center"
                  width="98%"
                >
                  <PublicHeader />

                  <Box 
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        textAlign: "center"
                    }}
                    height="calc(100% - 80px)"
                  >
                    <Typography
                      sx={{
                        width: "100%",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 700,
                        fontSize: 24,
                        lineHeight: "100%",
                        letterSpacing: "-0.04em",
                        color: "#1C492D",
                      }}
                    >
                      I tuoi dati
                    </Typography>


                    <Typography
                      sx={{
                        width: "100%",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                        fontSize: 16,
                        lineHeight: "100%",
                        letterSpacing: "-0.04em",
                        color: "#1C492D",
                      }}
                      mt="20px"
                    >
                      Nome
                    </Typography>
                    <Typography
                      sx={{
                        width: "100%",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: 24,
                        lineHeight: "100%",
                        letterSpacing: "-0.04em",
                        color: "#1C492D",
                      }}
                    >
                      {name}
                    </Typography>


                    <Typography
                      sx={{
                        width: "100%",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                        fontSize: 16,
                        lineHeight: "100%",
                        letterSpacing: "-0.04em",
                        color: "#1C492D",
                      }}
                      mt="20px"
                    >
                      Email
                    </Typography>
                    <Typography
                      sx={{
                        width: "100%",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: 24,
                        lineHeight: "100%",
                        letterSpacing: "-0.04em",
                        color: "#1C492D",
                      }}
                    >
                      {email}
                    </Typography>


                    <button
                        className="btn flex gap-2 mb-4 btn-light"
                        style={{ backgroundColor: "#D23E3E", color: "white", marginTop: '20px' }}
                        onClick={() => {
                            const deleteUser = async () => {
                                await handleDeleteUser();
                            }
                            setModalData({
                                show: true,
                                title: "Elimina utenza",
                                message: "Se decidi di procedere, questa utenza verrà eliminata definitivamente. L'azione non è reversibile.",
                                type: MODALTYPE.DELETE,
                                action: deleteUser
                            })
                        }}
                    >
                        <img src={deluser} alt="deluser" width={15} style={{marginRight: "10px"}} />
                        Elimina profilo
                    </button>

                  </Box>

                <button
                    className="btn flex gap-2 mb-4 btn-light"
                    style={{ backgroundColor: "#fff0", color: "#D23E3E" }}
                    onClick={handleDisconnectClick}
                >
                    <LogoutIcon sx={{ marginRight: '10px' }} />
                    Disconnetti
                </button>

                </Box>
                <ModalAlert modalData={modalData} onClose={closeModal} />
                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                  >
                    <Alert
                      onClose={() => setSnackbarOpen(false)}
                      sx={{
                        width: "100%",
                        backgroundColor: "black",
                        color: "white",
                        borderRadius: 3,
                      }}
                      icon={snackbarMessage.icon}
                    >
                      {snackbarMessage.message}
                    </Alert>
                  </Snackbar>

            </PublicLayout>
        }
        </>
    );
};

export default GestionePrivacy;
